export default __webpack_public_path__ + "static/media/f_socialmedialist.b30c4b07.svg";